import React from 'react'

import styled from 'styled-components'

import { theme } from 'app/match/applicationReportPDF/assets/theme'
import * as helpers from 'app/sm/helpers'

const FooterHeading = styled.h4`
  font-size: ${theme.fontSizes[3]}px;
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.gray900};
  margin-bottom: ${theme.space[1]}px;
`

const FooterLink = styled.a`
  display: inline-block;
  vertical-align: top;
  font-size: ${theme.fontSizes[3]}px;
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.gray900};
  text-decoration: none;
  margin-bottom: ${theme.space[2]}px;
`

const FooterContainer = styled.footer`
  margin-top: ${theme.space[4]}px;
  @media print {
    page-break-inside: avoid;
  }
`

const DisclaimerText = styled.p`
  font-size: ${theme.fontSizes[1]}px;
  color: ${theme.colors.gray700};
  margin-bottom: 0;
`

const Footer = ({ teamSlug = '', agencyDetails = {} }) => {
  const { companyName = '', licenseNumber = '' } = agencyDetails
  return (
    <FooterContainer id="footer">
      <div className="container text-center">
        <FooterHeading>Book a viewing and start an application</FooterHeading>
        <FooterLink
          target="_blank"
          rel="noopener noreferrer"
          href={`${helpers.urlTo('teamPublicPage', { teamSlug })}`}
        >
          snug.com/apply/{teamSlug}
        </FooterLink>
        <DisclaimerText>
          Disclaimer, {companyName}, License: {licenseNumber}
        </DisclaimerText>
      </div>
    </FooterContainer>
  )
}

export default Footer
